<div class="popup-content">
    <div>
        <h3>Thêm tài liệu cho Quỹ</h3>
    </div>

    <div class="modal-body">
        <div class="form-group">
            <div class="create-date">
                <label
                    class="control-label input-title no-padding d-flex">Loại tài liệu
                    <span class="required">(*)</span>
                </label>
                <div class="input-group">
                    <dropdown
                        [list]="documents"
                        [key]="'code'"
                        (result)="changeType($event)"
                        [title]="'Chọn loại tài liệu'"
                    >
                    </dropdown>
                </div>
            </div>
            <app-error-text [isDisplay]="isSaved && !typeCode" [message]="' Vui lòng chọn loại tài liệu.'">
            </app-error-text>
        </div>
        <div class="form-group">
            <div class="create-date">
                <label
                    class="control-label input-title no-padding d-flex">Ngày hiệu lực
                    <span class="required">(*)</span>
                </label>
                <div class="input-group">
                    <input-date [(value)]="tday">
                    </input-date>
                </div>
            </div>
            <app-error-text [isDisplay]="isSaved && checkDateNull()" [message]="' Vui lòng chọn ngày.'">
            </app-error-text>
        </div>
        <div class="form-group">
            <label
                class="control-label input-title no-padding d-flex">Import file 
                <span class="required">(*)</span>
            </label>
            <div class="d-flex flex-row m-t-15 m-b-15" [ngClass]="{'custom-disabled': !tday || !typeCode}">
                <button nz-button nzType="primary" class="btn-chooseFile" (click)="uploadFile();">Chọn file</button>
                <input type="text" value="" placeholder="Tên file" [(ngModel)]="fileName">
                <input id="fileInput" #fileInput style="display: none;" name="file" type="file" (change)="selectFile($event)"
                ng2FileSelect  [uploader]="uploaderImage"/>
            </div>
            <app-error-text [isDisplay]="isSaved && !urlImage" [message]="' Vui lòng chọn file.'">
            </app-error-text>
        </div>
    </div>
    


    <div class="modal-footer">
        <button nz-button nzType="default" class="mr-4" (click)="cancel()">Cancel</button>
        <button nz-button nzType="primary" class="admin-btn_create" (click)="save()" [ngClass]="!urlImage && 'custom-disabled'">Import</button>

    </div>
</div>